import { makeStyles } from '@material-ui/core/styles';

import SearchIcon from '../../../images/search-icon.svg';

const heightBySize = size => {
  switch (size) {
    case 'small':
      return 32;
    case 'medium':
      return 40;
    case 'large':
      return 48;
    case 'none':
      return 'none';
    default:
      return 32;
  }
};

const useStyles = makeStyles(theme => ({
  controlWrapper: {
    // Only the disabled control paints a background. An enabled control inherits its
    // container's, so the borderless inlineSearch variant sits on a tinted surface.
    background: props => (props.isDisabled ? theme.palette.common.gray100 : undefined),
    border: props => {
      if (props.inlineSearch) {
        return 'none';
      }
      if (props.error) {
        return theme.customBorders.error;
      }
      if (props.menuIsOpen || props.isFocused) {
        return theme.customBorders.primary;
      }
      return theme.customBorders.gray300;
    },
    borderRadius: 3,
    // The border keeps its color when the control is disabled, so a field that
    // is both invalid and disabled still reads as invalid. The dashed style is
    // the non-color cue. inlineSearch has no border to restyle.
    borderStyle: props => (props.isDisabled && !props.inlineSearch ? 'dashed' : undefined),
    boxShadow: theme.customShadows.selectDropdown,
    cursor: props => (props.isDisabled ? 'not-allowed' : 'pointer'),
    maxHeight: ({ isMulti, size }) => (isMulti ? 'none' : heightBySize(size)),
    minHeight: ({ size }) => heightBySize(size),
    padding: theme.spacing(0.5, 2, 0.5, 2.5),
    transition: 'border-color 0.3s ease',
    // AXHE-2845: react-select sets isFocused whenever the control receives
    // focus — both keyboard tab and mouse click set it. Previously only
    // menuIsOpen restyled the control, so tabbing onto a closed select showed
    // no focus indicator (WCAG 2.4.7). Add a visible focus ring for any
    // focused control. Skip it for inlineSearch (deliberately borderless inside
    // its own bordered popover) and when error is set (the red error border
    // wins, mirroring the border logic above) so we never mix error and
    // default-focus colors.
    outline: props =>
      props.isFocused && !props.inlineSearch && !props.error ? `2px solid ${theme.palette.primary.main}` : 'none',
    outlineOffset: props => (props.isFocused && !props.inlineSearch && !props.error ? 1 : 0),
  },
  inlineSearch: {
    background: theme.palette.common.gray100,
    backgroundImage: `url("${SearchIcon}")`,
    backgroundPositionX: theme.spacing(2),
    backgroundPositionY: 'center',
    backgroundRepeat: 'no-repeat',
    paddingLeft: theme.spacing(5.5),
  },
}));

export default useStyles;
